import { Button, Form, Input, Select, Space, message } from "antd";
import React, { useEffect, useState } from "react";
import FlagMapper, { FlagTypes } from "../../Util/FlagMapper";
import api from "../../api/api";

const AddNewTypeForm = ({
  exportedTypesFromAnswers,
  exportedAdjectiveFromAnswers,
  importantAreas = [],
  productCode,
  roadmap,
  onFinish,
  onEdit,
  formData,
  userTypeData,
  isEditing = false,
  loadType = (id) => {},
}) => {
  const [form] = Form.useForm();
  const [selectData, setSelectData] = useState({});

  useEffect(() => {
    if (!isEditing) {
      form.setFieldsValue({
        tag: Array.from(new Set([...exportedAdjectiveFromAnswers])),
        types: exportedTypesFromAnswers,
        area: importantAreas.map((e) => e.area),
      });
    }
  }, [exportedAdjectiveFromAnswers, exportedTypesFromAnswers, importantAreas]);

  const monthNames = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ];

  const makeNewType = () => {
    api
      .post("roadmaptypes", {
        ...form.getFieldsValue(),
        types: form.getFieldValue("types") ?? [],
        flagsRoadmap: roadmap,
        product: productCode,
      })
      .then((res) => {
        message.success("تایپ با موفقیت ساخته شد");
        onFinish(res.data.id);
      });
  };

  const updateType = () => {
    api
      .put("roadmaptypes/" + formData.id, {
        ...form.getFieldsValue(),
        flagsRoadmap: roadmap,
        types: form.getFieldValue("types") ?? [],
      })
      .then((res) => {
        onEdit(formData.id, form.getFieldsValue());
        loadType(formData.id);
      });
  };

  const getRoadmapPeriod = () => {
    const term1 = (roadmap?.term1?.title ?? "")?.split(" و ")?.at(0)?.trim();
    const term4 = (roadmap?.term4?.title ?? "")?.split(" و ")?.at(1)?.trim();

    const isTerm1MonthName = monthNames.find((el) => el === term1);
    const isTerm4MonthName = monthNames.find((el) => el === term4);

    if (!isTerm1MonthName || !isTerm4MonthName) return;

    const tempPeriod = `${term1} تا ${term4}`;

    const period = form.getFieldValue("period");

    const isExistsInPeriod = period?.find((el) => el === tempPeriod);

    if (isExistsInPeriod) return;
    if (isExistsInPeriod) return;

    if (Array.isArray(period)) {
      form.setFieldValue("period", [...period, tempPeriod]);
    } else {
      form.setFieldValue("period", [tempPeriod]);
    }
  };

  useEffect(() => {
    if (userTypeData?.age) {
      form.setFieldValue("age", `${userTypeData?.age}`);
    }
    if (userTypeData?.gender) {
      form.setFieldValue(
        "gender",
        userTypeData?.gender === "آقا" ? "man" : "woman"
      );
    }
  }, [userTypeData]);

  useEffect(() => {
    getRoadmapPeriod();
  }, [roadmap]);

  useEffect(() => {
    if (formData) {
      form.setFieldsValue(formData);
    }
  }, [formData]);

  const changeTypeValue = (q, newValue) => {
    form.setFieldValue(
      "types",
      (form.getFieldValue("types") ?? []).map((a) =>
        a.question == q ? { question: q, value: newValue } : a
      )
    );
  };

  return (
    <Form
      form={form}
      name="validateOnly"
      layout="vertical"
      autoComplete="off"
      style={{ direction: "rtl" }}
    >
      <Form.Item name="title" label="عنوان">
        <Input />
      </Form.Item>
      <p
        style={{
          color: "rgba(0,0,0,0.75)",
          fontSize: "0.75rem",
          marginTop: 0,
        }}
      >
        در یک جمله کوتاه تایپ کاربر را توصیف کنید، مثلا پسر دانشجویی که مسئله‌اش
        فقط کار و ازدواج است
      </p>

      {/* <Form.Item
        name="age"
        label="سن"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input type="number" />
      </Form.Item>
      <Form.Item
        name="gender"
        label="جنسیت"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          style={{
            width: "100%",
          }}
          placeholder="انتخاب کنید"
          options={[
            { label: "زن", value: "woman" },
            { label: "مرد", value: "man" },
            // { label: "هر دو", value: "both" },
          ]}
        />
      </Form.Item> */}

      {(form.getFieldValue("types") ?? []).map((e) => (
        <Form.Item label={e.question ?? "جنسیت"}>
          <Input
            defaultValue={e.value}
            onChange={(event) => {
              changeTypeValue(e.question, event.target.value);
            }}
          />
        </Form.Item>
      ))}
      <Form.Item name="area" label="حوزه‌های کلیدی">
        <Select
          mode="multiple"
          allowClear
          style={{
            width: "100%",
          }}
          placeholder="انتخاب کنید"
          options={FlagTypes.map((el) => {
            return { label: FlagMapper(el).title, value: el };
          })}
        />
      </Form.Item>
      <Form.Item name="tag" label="صفت‌ها">
        <Select
          mode="tags"
          allowClear
          style={{ width: "100%" }}
          placeholder="صفت‌ها را وارد کنید"
        >
          {selectData?.tag?.map((tag) => (
            <Select.Option key={tag} value={tag}>
              {tag}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name="period" label="بازه‌های زمانی">
        <Select
          mode="tags"
          allowClear
          style={{
            width: "100%",
          }}
          placeholder="بازه های زمانی را وارد کنید"
        >
          {selectData?.period?.map((period) => (
            <Select.Option key={period} value={period}>
              {period}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name="description" label="توضیحات">
        <Input />
      </Form.Item>
      <Form.Item>
        <Space>
          {formData && (
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => {
                updateType();
              }}
            >
              ویرایش
            </Button>
          )}
          {
            <Button
              type={formData ? "default" : "primary"}
              htmlType="submit"
              onClick={() => {
                makeNewType();
              }}
            >
              ساخت
            </Button>
          }
          <Button htmlType="reset" type="link" danger>
            حذف مقادیر
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};
export default AddNewTypeForm;
